export default __webpack_public_path__ + "static/media/bestAndWorstCategories.43ec0d11.png";